import { IContentItemElements } from '@kontent-ai/delivery-sdk';

import { MULTI_WORD_MAKE_NAMES } from '../../Constants/Makes';
import { Locale } from '../../Entities/Locale/Locale.entity';

export const getSlugFromReviewsAndMakes = (
  reviews: IContentItemElements,
  makeList: string[],
  locale: Locale,
): string => {
  const slugValue = reviews.slug?.value || reviews.slug || '';
  let slug = slugValue.replace(/-/g, '_').replace('_review', '');

  const hasMultiWordMakeName: string | undefined = MULTI_WORD_MAKE_NAMES.find(
    name => slug.indexOf(name) > -1,
  );

  const make = hasMultiWordMakeName || makeList.find(m => slugValue.startsWith(m));

  slug = slug.replace(`${make}_`, '');

  return make ? (locale !== 'uk' ? slug : `${make}/${slug}`) : slug.replace(/_/, '/');
};
